module.exports = __webpack_public_path__ + "static/media/Artgrow.deca33b5.md";